const titlecase = require('./titlecase');

module.exports = {
  titlecase,
};
